import { useCallback, useMemo } from "react"
import { Paper } from "@mui/material"
import { ErrorBlock } from "components/controls/errorInfo"
import { Loading } from "components/controls/loading"

import { useListAuthorLinks } from "interface/author"
import { KojinResult, useListKojin } from "interface/kojin"
import { SearchDetailResult } from "interface/search"

import { KojinPreviewDialog } from "features/kojin/dialog/preview"
import { useKojinPreviewDialog } from "features/kojin/dialog/preview/hooks"

import { AuthorGraph } from "features/kojin/components/authorGraph"

type AuthorGraphPageProps = {
	search: SearchDetailResult
}
export const AuthorGraphPage = ({
	search
}: AuthorGraphPageProps) => {
	const { kojinCode, authorId, openKojin, openAuthor, close } = useKojinPreviewDialog()

	const onFetched = useCallback(
		(result: KojinResult[]) => {
			result.sort((a, b) => {
				if (a.score?.rank && b.score?.rank) {
					return a.score.rank - b.score.rank
				}
				if (a.isiNameKana && b.isiNameKana) {
					return a.isiNameKana.localeCompare(b.isiNameKana)
				}
				return 0
			})
		},
		[]
	)
	const listState = useListKojin(search.searchId, undefined, {
		updateTime: search.updateTime,
		rankLimit: 1000,
		onFetched
	})
	const progress = useMemo(
		() => listState.loaded && listState.total ? (listState.loaded / listState.total) * 100 : undefined,
		[listState]
	)
	const linkState = useListAuthorLinks(search.searchId, { updateTime: search.updateTime })

	return (
		<Paper sx={{ width: '100%', height: '100%', position: 'relative' }}>
			{listState.loading ? <Loading percent={progress}/> :
				linkState.loading ? <Loading /> : <></>}
			
			<ErrorBlock error={[listState, linkState].flatMap(state => state.error ?? [])} />

			<AuthorGraph
				kojinList={listState.data ?? null}
				linkList={linkState.data?.list ?? null}
				onSelectKojin={openKojin}
				onSelectAuthor={openAuthor}
			/>

			{(kojinCode || authorId) ? (
				<KojinPreviewDialog
					kojinCode={kojinCode ?? undefined}
					authorId={authorId ?? undefined}
					onClose={close}
				/>
			) : <></>}
		</Paper>
	)
}
